export const SEARCH_FIELDS_FRAGMENT = `
  fragment searchResultMetaFields on SearchResultMeta {
    location {
      cityName: city_name
      cityUname: city_uname
      isoCode: country_iso_code
      countryName: country_name
      geohash
      lat
      lon
      neighborhoodUname: neighborhood_uname
      neighborhoodName: neighborhood_name
      postcode
    }
    options {
      fulfillmentMethod: fulfillment_method
      deliveryTime: delivery_time
      params {
        id
        value
      }
      query
    }
    restaurantCount: restaurant_count {
      results
      location
    }
    searchPlaceholder: search_placeholder
    title
    collection {
      linkTitle: link_title
      target_params {
        ...uiTargetParamsFields
      }
    }
    uuid
    web {
      url
    }
    warnings {
      warning_type
    }
  }
`;

export const TARGET_FRAGMENT = `
  fragment uiTargetFields on UITarget {
    typeName: __typename
    ...on UITargetRestaurant {
      restaurant {
        id
        name
        links {
          self {
            href
          }
        }
      }
    }
    ...on UITargetParams {
      ...uiTargetParamsFields
    }
    ...on UITargetAction {
      action
    }
    ...on UITargetMenuItem {
      menuItem: menu_item {
        id
      }
      links {
        href
      }
    }
  }
`;

export const CURRENCY_FRAGMENT = `
  fragment currencyFields on Currency {
    formatted
    presentational
  }
`;

export const RESTAURANT_FRAGMENT = `
  fragment restaurantFields on Restaurant {
    id
    categoryNames: category_names
    deliveryFee: delivery_fee {
      ...currencyFields
    }
    deliveryStatus: delivery_status
    deliveryTime: delivery_time {
        qualifier
        qualifierPosition: qualifier_position
        text
    }
    isEditions: editions
    name
    images {
      default
    }
    minimumOrderValue: minimum_order_value {
      ...currencyFields
    }
    name
    newlyAdded: newly_added
    ratingCount: rating_count_presentational
    ratingPercent: rating_percent
    offer: offer_presentational
    links {
      self {
        href
      }
    }
  }
`;

export const BLOCK_FRAGMENT = `
  fragment uiBlockFields on UIBlock {
    typeName: __typename
    ...on UIBanner {
      key
      header
      caption
      buttonCaption: button_caption
      target {
        ...uiTargetFields
      }
      images {
        icon {
          ...iconFields
        }
        image
      }
      theme: ui_theme
      trackingId: tracking_id
    }
    ...on UIRestaurant {
      key
      restaurant {
        ...restaurantFields
      }
      theme: ui_theme
      trackingId: tracking_id
    }
    ...on UIShortcut {
      key
      images {
        default
      }
      name
      target {
        ...uiTargetFields
      }
      theme: ui_theme
      trackingId: tracking_id
    }
    ...on UICard {
      key
      trackingId: tracking_id
      theme: ui_theme
      target {
        ...uiTargetFields
      }
      uiContent: properties {
        default {
          ...uiCardFields
        }
        expanded {
          ...uiCardFields
        }
      }
    }
  }
`;

export const UI_CARD_FRAGMENT = `
  fragment uiCardFields on UICardFields {
    bubble {
      qualifier
      qualifierPosition: qualifier_position
      text
    }
    overlay {
      backgroundColor: background_color {
        ...colorFields
      }
      text {
        position
        color {
          ...colorFields
        }
        value
      }
      badge {
        position
        color: background_color {
          ...colorFields
        }
        uiLine: ui_line {
          ...uiLines
        }
      }
    }
    image
    uiLines: ui_lines {
      ...uiLines
    }
  }
`;

export const UI_LINES_FRAGMENT = `
  fragment uiLines on UILine {
    typeName: __typename
    ...on UITextLine {
      key
      uiSpans: ui_spans {
        typeName: __typename
        ...on UISpanIcon {
          key
          color {
            ...colorFields
          }
          icon {
            ...iconFields
          }
          iconSize: size
        }
        ...on UISpanSpacer {
          key
          width
        }
        ...on UISpanText {
          key
          color {
            ...colorFields
          }
          text
          isBold: is_bold
          textSize: size
        }
      }
    }
    ...on UITitleLine {
      key
      text
      color {
        ...colorFields
      }
    }
  }
`;

export const FULFILLMENT_METHOD_FIELDS_FRAGMENT = `
  fragment uiControlFulfillmentMethodFields on UIControlFulfillmentMethod {
    label
    targetMethod: target_method
  }
`;

export const CONTROL_FIELDS_FRAGMENT = `
  fragment uiControlFilterFields on UIControlFilter {
    id
    header
    images {
      icon {
        name
        image
      }
    }
    optionsType: options_type
    options {
      count
      default
      name: header
      id: key
      selected
      target_params {
        ...uiTargetParamsFields
      }
    }
    styling {
      web {
        desktop {
          collapse
        }
        mobile {
          collapse
        }
      }
    }
  }
`;

export const APPLIED_FILTER_FIELDS_FRAGMENT = `
  fragment uiControlAppliedFilterFields on UIControlAppliedFilter {
    label
    target_params {
      ...uiTargetParamsFields
    }
  }
`;

export const LAYOUT_FIELDS_FRAGMENT = `
  fragment uiLayoutFields on UILayout {
    typeName: __typename
    ...on UILayoutCarousel {
      header
      target {
        ...uiTargetFields
      }
      targetPresentational: target_presentational
      key
      blocks: ui_blocks {
        ...uiBlockFields
      }
      trackingId: tracking_id
    }
    ...on UILayoutList {
      header
      key
      blocks: ui_blocks {
        ...uiBlockFields
      }
      trackingId: tracking_id
    }
  }
`;

export const TARGET_PARAMS_FRAGMENT = `
  fragment uiTargetParamsFields on UITargetParams {
    params {
      id
      value
    }
    queryParams: query_params
    title
    typeName: __typename
  }
`;

export const QUERY_RESULTS_FRAGMENT = `
  fragment uiControlQueryResultFields on UIControlQueryResult {
    header
    key
    options {
      key
      count
      highlights {
        begin
        end
      }
      uiLines: ui_lines {
        ...uiLines
      }
      image {
        type: __typename
        ...on DeliverooIcon {
          ...iconFields
        }
        ...on UIControlQueryResultOptionImageSet {
          default
        }
      }
      label
      isAvailable: is_available
      target {
        ...uiTargetFields
      }
    }
  }
`;

export const COLOR_FIELDS_FRAGMENT = `
  fragment colorFields on Color {
    hex
    r: red
    g: green
    b: blue
    a: alpha
  }
`;

export const DELIVEROO_ICON_FRAGMENT = `
  fragment iconFields on DeliverooIcon {
    name
    image
  }
`;

export const SEARCH_BLOCK_FRAGMENT = `
  fragment uiBlockFields on UIBlock {
    typeName: __typename
    ...on UIBanner {
      key
      header
      caption
      buttonCaption: button_caption
      target {
        ...uiTargetFields
      }
      images {
        icon {
          ...iconFields
        }
        image
      }
      theme: ui_theme
      trackingId: tracking_id
    }
  }
`;

export const SEARCH_LAYOUT_FIELDS_FRAGMENT = `
  fragment uiLayoutFields on UILayout {
    typeName: __typename
    ...on UILayoutList {
      header
      key
      blocks: ui_blocks {
        ...uiBlockFields
      }
      trackingId: tracking_id
    }
  }
`;

export const FULFILLMENT_TIME_OPTION_FIELDS_FRAGMENT = `
  fragment fulfillmentTimeOptionFields on FulfillmentTimeOption {
    optionLabel: option_label
    selectedLabel: selected_label
    timestamp(format: UNIX)
    selectedTime: selected_time {
      day
      time
    }
  }
`;

export const UI_PIN_FIELDS_FRAGMENT = `
  fragment uiPinFields on UIMapPin {
    ...on UIRestaurantPin {
      image
      lat
      lon
      restaurantId: restaurant_id
      tooltipText: tooltip_text
    }
  }
`;

export const MAP_BLOCK_FRAGMENT = `
  fragment uiBlockFields on UIBlock {
    typeName: __typename
    ...on UICard {
      key
      trackingId: tracking_id
      theme: ui_theme
      target {
        ...uiTargetFields
      }
      uiContent: properties {
        default {
          ...uiCardFields
        }
      }
    }
  }
`;

export const MAP_LAYOUT_FIELDS_FRAGMENT = `
  fragment uiLayoutFields on UILayout {
    typeName: __typename
    ...on UILayoutCarousel {
      header
      target {
        ...uiTargetFields
      }
      targetPresentational: target_presentational
      key
      blocks: ui_blocks {
        ...uiBlockFields
      }
      trackingId: tracking_id
    }
  }
`;

export const UI_CARD_WIDE_FRAGMENT = `
  fragment uiCardFields on UICardFields {
    overlay {
      backgroundColor: background_color {
        ...colorFields
      }
      text {
        position
        color {
          ...colorFields
        }
        value
      }
    }
    image
    uiLines: ui_lines {
      ...uiLines
    }
  }
`;
